import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import UploadIcon from '@mui/icons-material/Upload';
import ImageUploading from 'react-images-uploading';
import Modal, { ModalTypes } from '@/trio-ui/Modal';
import TransparentButton from '@/trio-ui/TransparentButton';
import * as Styles from './PictureUpload.styles';

type ImageByURL = {
  isValid: boolean;
  value: string;
  hasPasted: boolean;
};

export type Props = Pick<ModalTypes, 'onClose' | 'isOpen'> & {
  isSaving?: boolean;
  images: any[];
  onChange: (event: any) => void;
  onChangeText: (event: any) => void;
  onInvalidImage: () => void;
  onSaveImage: () => void;
  onDeleteImages: () => void;
  imageByUrl: ImageByURL;
  disableFileInput?: boolean;
  disableUrlInput?: boolean;
};

export default function PictureUpload({
  isSaving,
  images,
  onChange,
  onChangeText,
  onInvalidImage,
  onSaveImage,
  onDeleteImages,
  imageByUrl,
  disableFileInput = false,
  disableUrlInput = false,
  ...props
}: Props): JSX.Element {
  return (
    <Modal
      {...props}
      modalTitle="Add profile picture"
      isCentered
      hideCancelButton
      bodyRender={
        <Styles.Box>
          <ImageUploading value={images} onChange={onChange}>
            {({ imageList, onImageUpload }) => {
              return (
                <div>
                  {!disableFileInput && (
                    <Styles.UploadImageButton
                      disabled={isSaving}
                      type="button"
                      onClick={onImageUpload}
                    >
                      <UploadIcon />
                      Upload Image
                    </Styles.UploadImageButton>
                  )}
                  {!disableFileInput && !disableUrlInput && <Styles.OrText>or</Styles.OrText>}
                  {!disableUrlInput && (
                    <Styles.ImageUrlInput
                      placeholder="Paste image URL"
                      type="text"
                      disabled={isSaving}
                      value={imageByUrl.value}
                      onChange={onChangeText}
                    />
                  )}

                  {imageList.map((image, index) => (
                    <Styles.Image key={index.toString()} src={image.dataURL} alt="" width="100" />
                  ))}

                  {imageByUrl.value && imageByUrl.isValid && imageByUrl.hasPasted && (
                    <Styles.Image onError={onInvalidImage} alt="" src={imageByUrl.value} />
                  )}

                  {(imageList.length || imageByUrl.isValid) && (
                    <Styles.Footer>
                      <TransparentButton
                        isBlueButton
                        type="button"
                        icon={SaveIcon}
                        disabled={isSaving}
                        onClick={onSaveImage}
                      >
                        {isSaving ? 'Saving...' : 'Save'}
                      </TransparentButton>
                      <TransparentButton
                        isRedButton
                        icon={CancelIcon}
                        type="button"
                        disabled={isSaving}
                        onClick={onDeleteImages}
                      >
                        Cancel
                      </TransparentButton>
                    </Styles.Footer>
                  )}

                  {imageByUrl.value && !imageByUrl.isValid && (
                    <Styles.InvalidWarning>
                      <CancelIcon />
                      Invalid Image
                    </Styles.InvalidWarning>
                  )}
                </div>
              );
            }}
          </ImageUploading>
        </Styles.Box>
      }
    />
  );
}
